(function(){
    'use strict';
    angular.module('Filters').filter('truncateText', truncateText);
    truncateText.$inject = [];

    function truncateText() {
        return function (text, limit) {
            if (!text) { return; }
            if (text.length > limit) {
                return `${text.substring(0, limit)}...`;
            }

            return text;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/filters/truncateText.js